import React from 'react';
import './TalentCard.css'; 
import {useNavigate } from 'react-router-dom';

const MissionCard = ({ missions = [] }) => {
  const navigate = useNavigate();
  const userRole = localStorage.getItem('userType')?.toLowerCase();
  const isClickable = userRole !== 'admin';
  return (
    <div className="talent-card">
      <h3>Missions suggérées</h3>
      {missions.length === 0 ? (
        <p className="no-talent">Aucune mission suggérée pour le moment.</p>
      ) : (
        <ul className="talent-list">
          {missions.map((mission, index) => (
            <li  key={index}
            className="talent-item"
            onClick={isClickable ? () => navigate(`/Recruteur/Details/${mission._id}`): undefined}
            style={{ cursor: 'pointer' }}>
              <div className="talent-name">{mission.nomMission}</div>
              <div className="talent-job"> Similarité {(mission.similarity * 100).toFixed(2)}%</div>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
};

export default MissionCard;
